import React from 'react';
import { Building2, User } from 'lucide-react';
import { sponsors } from '../../data/mock';
import { getOptimizedImageUrl } from '../../lib/utils';

const SponsorsSection = () => {
  return (
    <section data-testid="sponsors-section" className="relative py-20 md:py-32 bg-cream-dark overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-dwarfpony text-sm font-semibold tracking-wider uppercase mb-4">
            Our Supporters
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-deepwalnut mb-6">
            Backed by <span className="text-richolive">Industry Leaders</span>
          </h2>
          <p className="text-heavyrain text-lg max-w-2xl mx-auto">
            Organizations and individuals supporting STEM education and innovation in India
          </p>
        </div>

        {/* Sponsors Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {sponsors.map((sponsor, index) => (
            <div
              key={index}
              className="bg-white border border-pragmatic/30 rounded-xl p-6 flex flex-col items-center justify-center min-h-[180px] hover:border-dwarfpony transition-all group shadow-sm"
            >
              {/* Logo or Placeholder */}
              <div className="h-24 w-full flex items-center justify-center mb-4">
                {sponsor.logo ? (
                  <img
                    src={getOptimizedImageUrl(sponsor.logo, 400)}
                    alt={sponsor.name}
                    className="h-full w-auto object-contain"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-16 h-16 rounded-full bg-pragmatic/10 flex items-center justify-center">
                    {sponsor.isIndividual ? (
                      <User className="w-8 h-8 text-dwarfpony" />
                    ) : (
                      <Building2 className="w-8 h-8 text-dwarfpony" />
                    )}
                  </div>
                )}
              </div>

              {/* Name */}
              <p className="text-deepwalnut font-semibold text-sm text-center group-hover:text-dwarfpony transition-colors">
                {sponsor.name}
              </p>
              {sponsor.isIndividual && (
                <p className="text-heavyrain text-xs mt-1">(Individual)</p>
              )}
            </div>
          ))}
        </div>

        {/* FIRST Global Sponsors Note */}
        <div className="mt-12 text-center">
          <p className="text-heavyrain text-sm">
            FIRST Global is additionally supported by MIT, NASA, Yale, Boeing, Google.org, and many more global partners
          </p>
        </div>
      </div>
    </section>
  );
};

export default SponsorsSection;
